import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { appInsights } from '../../app.module';

import { AuthService } from '../../auth/auth.service';
import {Configuration} from '../../configuration';

class LoginModel {
    email: string;
    password: string;
}

@Component({
    selector: 'account/login',
    template: require('./login.component.html'),
    styles: [require('./login.component.css')]
})

export class LoginComponent implements OnInit {
    model = new LoginModel();
    loading = false;
    publicFacingUrl: string;
    error = '';
    
    constructor(
        private readonly router: Router,
        private readonly authenticationService: AuthService,
        private readonly config: Configuration) { 
            this.publicFacingUrl = config.routing.publicFacingUrl;
        }

    ngOnInit() {
        // reset login status
        this.authenticationService.logout(null, '/account/login');
    }

    login() {
        this.loading = true;
        this.authenticationService.login(this.model.email, this.model.password)
            .subscribe(result => {
                if (result) {
                    this.authenticationService.canLogin(this.model.email).subscribe(response => {
                        if (response.canLogin || response.hasNoCategoriesOrLocations) {
                            appInsights.setAuthenticatedUserContext(this.model.email);
                            this.router.navigate(['/tenders/mymatches']);
                        } else if (response.isMemberOfExpiredSupplier) {
                            this.error = 'Your team leader\'s subscription has expired.';
                            this.loading = false;
                        } else {
                            this.error = 'Email or password is incorrect';
                            this.loading = false;
                        }
                    }, error => {
                        this.error = 'Email or password is incorrect';
                        this.loading = false;
                    });
                }
            }, (error: any) => {
                this.loading = false;
                const errorCode = error && (error.errorCode || (error.error && error.error.error_description));
                this.error = this.getLoginErrorMessage(errorCode);
            });
    }

    private getLoginErrorMessage(errorCode: string): string {
        switch (errorCode) {
            case 'account_locked':
                return 'Too many incorrect password attempts.';
            case 'ip_rate_limited':
                return 'Too many failed login attempts.';
            default:
                return 'Email or password is incorrect';
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/userAccounts/login.component.ts